// 데스크 FAQ 관리 화면 공용 유틸 — 날짜 표기, base64 엑셀 다운로드

const pad2 = (n : number) => (n < 10 ? "0" + n : "" + n);

// "11-02 14:10"
export const formatShortDateTime = (v : any) : string => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d.getTime())) return "";
    return `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

// "11-02"
export const formatMonthDay = (v : any) : string => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d.getTime())) return "";
    return `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

// "2026-11-02 14:10"
export const formatFullDateTime = (v : any) : string => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d.getTime())) return "";
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

export const toYmd = (d : Date) : string => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const formatNumber = (n : any) : string => {
    const v = +n;
    return isNaN(v) ? "0" : v.toLocaleString("ko-KR");
};

// 서버가 { fileName, base64 } 로 준 xlsx 를 Blob 으로 저장 (fetch 래퍼가 JSON 만 받아서)
export const downloadBase64Xlsx = (fileName : string, base64 : string) => {
    const bin = atob(base64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
        bytes[i] = bin.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const FEEDBACK_TYPE_LABEL : { [k : string] : string } = {
    no_answer : "답 없음",
    wrong_item : "다른 항목",
    wrong_content : "내용 틀림",
    helpful : "도움됐어요"
};

// 질문 묶기용 정규화 (서버 normalizeQuestion 과 같은 규칙)
export const normalizeQuestion = (q : string) : string => String(q || "").replace(/\s+/g, "").replace(/[?？]+$/g, "").toLowerCase();

export const toastOptions : any = { position : "bottom-right", autoClose : 3000, hideProgressBar : true, theme : "colored" };
